import { motion } from 'framer-motion';
import { Shield } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';

export default function AdultReloginGate() {
  const navigate = useNavigate();

  const handleContinue = () => {
    navigate('/adult/auth-choice');
  };

  return (
    <div className="adult-layout min-h-screen flex items-center justify-center">
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.4 }}
        className="max-w-md mx-auto px-4"
      >
        <div className="warm-card rounded-3xl p-12 text-center shadow-2xl">
          <div className="w-20 h-20 mx-auto mb-6 bg-gradient-to-br from-purple-500 to-blue-600 rounded-full flex items-center justify-center shadow-lg">
            <Shield className="w-10 h-10 text-white" />
          </div>
          
          <h1 className="adult-heading text-3xl font-bold text-gray-900 mb-4">
            For Grown-ups Only
          </h1>
          
          <p className="text-gray-600 mb-8 text-lg">
            This section is for parents and teachers to manage profiles,
            assign expeditions, and view insights.
          </p>

          <Button
            onClick={handleContinue}
            data-testid="continue-to-auth"
            className="w-full bg-gradient-to-r from-purple-500 to-blue-500 hover:from-purple-600 hover:to-blue-600 text-white h-14 rounded-xl text-lg font-bold shadow-lg mb-4"
          >
            Continue
          </Button>

          <Button
            onClick={() => navigate('/family')}
            data-testid="back-button"
            variant="ghost"
            className="w-full text-gray-600 hover:text-gray-900"
          >
            Go Back
          </Button>
        </div>
      </motion.div>
    </div>
  );
}
